const baseURL = "https://core.api.es6.vn/net";
const SessionID = "g0vN_r7zdt2rChiymKqQQ5uzlwsQsvKZ";
const timeout = 1000 * 60 * 5;

module.exports = {
    baseURL,
    timeout,
    SessionID,
    projectName: "core.es6.vn",
    stored: {
        GetPageInfor: "WPXHE1-wFtWpji7ZCv97bu8eUAtCDhU6p2XzYRBUxeI=",
        GetPasswordReset: "0DqAlMKtXqlXUdJd6BmoE7jzNUBqRcy5E2SgNsba0Wo=",
        AddProjectSEO: "n0xerVhNmck3ZWtD2kBVMfKgj8lPiDSD3QlCXAeU7WA=",
        GetMemberConfig: "vEMb-QUdLizDX8PP-h-H9wEfX7ni29TcwA6J88Hkoek=",

        link: {
            ahrefs: {
                GetDomainIgnore: "SlLY9RWVF/vJbOeOj4tCWL3caJId8DeAdMeC1h8IztU=",
            },
            ranking: {
                GetKeywordSearch: "PVkTpSJHEdvJ19czHaExo-jzsrDUnvyktADnZ4mhqtc=",
                AddKeywordSearch: "n0xerVhNmck3ZWtD2kBVMRhyUJ9reLkGrw3wcQy20c4=",
            },
        },
        seo: {
            prj: {
                GetProjectList: "F9nTmLKEi73rJFJKcJukudkqgHCbJ0SAk8Tfhk/UP8Y=",
                GetProjectDetail: "5pWLQhJfAp-gR2Mi1CB/5bnyrzriowIxrWPhn-YQY0s="
            },
            ranking: {
                UpdateKeywordList: "ayj24GD0BKmLmS4bjhu2Ksz2RsQQm0K1qpaK4dt7Iyc="
            }
        },
        auth: {
            UpdateMemberConfig: "iiTZi1UhOPsje7H/cDhChERpy-lID/l3SDrHO8DF2oY=",
            AddMemberConfig: "aIrctMohGh2g4ZEt0tttVBM7skIimLnfwy09MxXzifQ=",
        },

        dw: {
            CheckNewMember: "pEv6SSaE-Vlaig1-WpCPXcclzbUukO2GClliOI/W7mA=",
            GetTempMember: "PNqN92GUEhXs9lDoNV7twM7HcWs5cml2NDSEPaop6bY=",
        },
    },
};


// WEBPACK FOOTER //
// src/utils/api/net/config.js